<div class="warning" *ngIf="show">
    {{ 'kyb.not-validated' | translate }}
    <a routerLink="account/kyb" routerLinkActive="active" class="button">{{ 'shared.button.know-more' | translate }}</a>
</div>
